import { Typography, CircularProgress } from '@mui/material';
import Box from '@mui/material/Box';
import { sporttiaColors } from '../../theme/theme';

type SttFoldingCubeSpinnerProps = {
    active?: boolean;
    color?: string;
    message?: string;
};

export default function SttFoldingCubeSpinner({
    active = false,
    // Sobre fondo claro sólo `brandText` pasa de 3:1; ver SttFullPageSpinner.
    color = sporttiaColors.brandText,
    message = '',
}: SttFoldingCubeSpinnerProps) {
    return active ? (
        <>
            <Box mb={3}>
                <CircularProgress
                    sx={{
                        color: color,
                    }}
                />
            </Box>

            {message !== '' && (
                <Box>
                    <Typography variant="overline">{message}</Typography>
                </Box>
            )}
        </>
    ) : null;
}
